import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import HelmetWrapper from "../../HelmetWrapper";
import MealsStructure from "../../components/diet/meal/MealsStructure";
import ReactVortoxSpinner from "../../components/common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../components/payment-link-system/PaymentLinkTable";
import { selectAuth } from "../../components/auth/auth.selector";
import { fetchPartnersData } from "../../redux/website-reducers/websiteSlice";
import { formattedLongDate } from "../../components/common-data/Converts";
import { CheckCircleIcon, CrossCircleIcon } from "../../images/icons/icons";

const Partners = () => {
  const dispatch = useDispatch();
  const authData = useSelector(selectAuth);
  const userInfoData = authData.user;

  const { loading, partners } = useSelector((state) => state.webApi);
  const { data, pagination } = partners || {};

  const [isPage, setIsPage] = useState(0);
  const iniFilters = {
    limit: 10,
    page: isPage + 1,
  };
  const [filters, setFilters] = useState(iniFilters);

  function getPartnerLists(filters) {
    dispatch(
      fetchPartnersData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
    }));
  }, [isPage]);

  useEffect(() => {
    getPartnerLists(filters);
  }, [filters]);

  const tbColumns = [
    {
      dataField: "full_name",
      text: "Name/Mobile",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.full_name || "NA"}
            <br />
            <small
              style={{
                textTransform: "lowercase",
                textDecoration: "underline",
              }}
            >
              {row?.mobile || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "city",
      text: "city",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.city || "NA"}</span>;
      },
    },
    {
      dataField: "gym_name",
      text: "gym name",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.gym_name || "NA"}</span>;
      },
    },
    {
      dataField: "is_owner",
      text: "is owner",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.is_owner === "true" ? (
              <CheckCircleIcon />
            ) : (
              <CrossCircleIcon />
            )}
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added ? formattedLongDate(row.date_added) : ""}
          </span>
        );
      },
    },
  ];

  return (
    <HelmetWrapper title="WTF: Partners">
      <Container className="bg-cloud-k px-50px" fluid>
        <Row>
          <Col>
            <MealsStructure text={"Interested Partner"} />
          </Col>
        </Row>

        <Row>
          <Col>
            <div className="fullWidthFlexCenter overflowAuto separatedTable">
              {loading ? (
                <ReactVortoxSpinner />
              ) : (
                <PaymentLinkTable
                  tableData={data?.length > 0 ? data : []}
                  tableColumns={tbColumns}
                  tablePagination={pagination?.length > 0 ? pagination : []}
                  isPage={isPage}
                  setIsPage={(value) => setIsPage(value)}
                />
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default Partners;
